export const addMonths = (date, months) => {
    const nextMonth = new Date(date);
    nextMonth.setMonth(date.getMonth() + months);
    return (nextMonth.getFullYear() > 2000) ? nextMonth : date;
}